"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
const blackjack_scoring_1 = require("../blackjack-scoring");
const logic_types_1 = require("../logic-types");
class Player {
    get currentBet() {
        return this.betAmount;
    }
    get hasDoubled() {
        return this.isDouble;
    }
    get isBust() {
        return blackjack_scoring_1.BlackjackScoring.hasBust(this.currentScore);
    }
    get currentScore() {
        const playerCards = this.board.getPileByPileId(this.playerId);
        return blackjack_scoring_1.BlackjackScoring.calculateScore(playerCards.allCards, this.logicVersion);
    }
    get finalResult() {
        return this.result;
    }
    get displayHandName() {
        switch (this.playerId) {
            case logic_types_1.PileId.Player1:
                return "1️⃣";
            case logic_types_1.PileId.Player2:
                return "2️⃣";
            case logic_types_1.PileId.Player3:
                return "3️⃣";
            case logic_types_1.PileId.Player4:
                return "4️⃣";
            default:
                return "";
        }
    }
    get displayScore() {
        return blackjack_scoring_1.BlackjackScoring.playerDisplayScore(this.currentScore, this.isHandComplete);
    }
    get displayCards() {
        return this.allFaceCards
            .map((card) => card.displayDescription())
            .join(", ");
    }
    get displayResult() {
        switch (this.finalResult) {
            case logic_types_1.RoundResult.Push:
                return "Push";
            case logic_types_1.RoundResult.CroupierWin:
                return "Dealer Wins";
            case logic_types_1.RoundResult.PlayerWin:
                return "Won 🙌";
            case logic_types_1.RoundResult.PlayerBust:
                return "Bust 🤦";
            case logic_types_1.RoundResult.PlayerBlackjack:
                return "Blackjack 🚀";
            default:
                return "";
        }
    }
    get allCards() {
        return this.board.getPileByPileId(this.playerId).allCards;
    }
    get allFaceCards() {
        const playerCards = this.board.getPileByPileId(this.playerId);
        return playerCards.allCards.filter((card) => card.isFaceUp);
    }
    get hasReachedTargetScore() {
        return blackjack_scoring_1.BlackjackScoring.hasReachedTargetScore(this.currentScore);
    }
    get hasPlayerBlackjack() {
        const playerCards = this.board.getPileByPileId(this.playerId);
        if (playerCards.cardCount === 2 && this.playerId === logic_types_1.PileId.Player1) {
            const [firstCard, secondCard] = playerCards.allCards;
            if (firstCard.cardId && secondCard.cardId) {
                return blackjack_scoring_1.BlackjackScoring.hasPlayerBlackjack(firstCard.cardId, secondCard.cardId);
            }
        }
        return false;
    }
    // TODO: Add tests to this method
    get canSplit() {
        const playerCards = this.board.getPileByPileId(this.playerId);
        if (playerCards.cardCount === 2) {
            const [firstCard, secondCard] = playerCards.allCards;
            if (firstCard.cardId && secondCard.cardId) {
                return blackjack_scoring_1.BlackjackScoring.canSplitPlayerCards(this.playerId, firstCard.cardId, secondCard.cardId);
            }
        }
        return false;
    }
    calculateRoundResult(croupierScore) {
        return blackjack_scoring_1.BlackjackScoring.calculateRoundResult(this.currentScore, croupierScore);
    }
    constructor(playerId, board, logicVersion) {
        this.playerId = playerId;
        this.board = board;
        this.logicVersion = logicVersion;
        this.betAmount = 0;
        this.isDouble = false;
        this.isHandComplete = false;
    }
    clone() {
        const clonedPlayer = new Player(this.playerId, this.board.clone(), this.logicVersion);
        clonedPlayer.betAmount = this.betAmount;
        clonedPlayer.isDouble = this.isDouble;
        clonedPlayer.isHandComplete = this.isHandComplete;
        clonedPlayer.result = this.result;
        return clonedPlayer;
    }
    setBetAmount(amount) {
        this.betAmount = amount;
        this.isDouble = false; // Reset this when changing bet amounts
    }
    setDoubleBet(isDouble) {
        this.isDouble = isDouble;
    }
    setHandComplete(isComplete) {
        this.isHandComplete = isComplete;
    }
    setResult(result) {
        this.result = result;
    }
}
exports.Player = Player;
